import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { trackPageView } from './clinician-tracking'

export function useLocationTracker() {
  const location = useLocation()

  useEffect(() => {
    trackPageView()
  }, [location])

  return null
}
